import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isArray, isEqual } from "lodash";

import { getParam, truncate } from '../utils/utils';
import { listCodeLists } from '../utils/utilsCodeList';

import dsd from "../classes/clsDSD";
import * as PD from '../classes/pdStyle';


class ListCodeLists extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: 'loading',
            CodeLists: null
        };

        this.dsd = new dsd();
    }

    componentDidMount() { this.setup(); }

    componentDidUpdate(prevProps) {
        if (!isEqual(this.props, prevProps)) { this.setup(); }
    }

    loadData(filters) {

        const onLoad = function(arr) {
            this.setState({ CodeLists: arr, renderState: 'loaded' });
            if (this.state.onLoad) { this.state.onLoad(arr.length); }
        }.bind(this);

        const onError = function(e) {
            this.setState({ renderState: 'failed', errorMessage: e.message });
        }.bind(this);

        listCodeLists(this.dsd, filters, onLoad, onError);
    }

    setup() {

        let StateChange = {
            filters: {},
            columns: { owner: true, status: true },
            onLoad: null,
            renderState: 'loading'
        };

        if (getParam('filters', this.props))  { StateChange.filters = getParam('filters', this.props); }
        if (getParam('columns', this.props))  { StateChange.columns = getParam('columns', this.props); }
        if (getParam('onLoad', this.props))   { StateChange.onLoad  = getParam('onLoad', this.props); }

        this.setState(StateChange);
        this.loadData(StateChange.filters);
    }

    render() {

        if (this.state.renderState === 'failed') {
            return <PD.ErrorBox>A problem has occurred</PD.ErrorBox>;
        }

        if (this.state.renderState === 'loaded') {
            let arr = this.state.CodeLists;
            if (isArray(arr) && arr.length > 0) {
                return (
                    <PD.Table className="list">
                        <PD.Thead>
                            <PD.Tr>
                                <PD.Th>Name</PD.Th>
                                {this.state.columns.owner  && <PD.Th>Owner</PD.Th>}
                                {this.state.columns.status && <PD.Th>Status</PD.Th>}
                                <PD.Th>Description</PD.Th>
                            </PD.Tr>
                        </PD.Thead>
                        <PD.Tbody>
                            {arr.map((CodeList, pos) => (
                                <PD.Tr key={pos}>
                                    <PD.Td>
                                        <PD.PdNavLink to={`/codelist/${CodeList.id}`}>{CodeList.name}</PD.PdNavLink>
                                    </PD.Td>
                                    {this.state.columns.owner &&
                                        <PD.Td>{CodeList.Owner && CodeList.Owner.organisation}</PD.Td>
                                    }
                                    {this.state.columns.status &&
                                        <PD.Td>{CodeList.status}</PD.Td>
                                    }
                                    <PD.Td>
                                        <PD.MdPresent>{truncate(CodeList.description, 400)}</PD.MdPresent>
                                    </PD.Td>
                                </PD.Tr>
                            ))}
                        </PD.Tbody>
                    </PD.Table>
                );
            }
        }

        return <div />;
    }
}

export default function ListCodeLists_wrapper(props) {
    const navigation = useNavigate();
    const location  = useLocation();
    const params    = useParams();
    return <ListCodeLists {...props} navigation={navigation} location={location} params={params} />;
}
